export default __webpack_public_path__ + "static/media/24-hours.06d64049.svg";